<div class="d-flex row-cols-12">
  <div class="col-12">
  <h3 class="title float-start" translate="Settings.Branding">
    <span *ngIf="premiumRequired" class="mt-0 ms-2 border-radius-profile badge information bold" [ngClass]="{'bg-danger': !brandingAvailable, 'bg-success': brandingAvailable}" translate="Settings.Premium"></span> 
    <app-info-button *ngIf="premiumRequired && !brandingAvailable" labelName="Settings.OrganisationBrandingSection.BrandingTitleTooltip"></app-info-button>  
  </h3>
  </div>
</div>

<div class="mx-3 mt-1">
    <div class="mb-3 col-12">
        <nav ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-0">
            <ng-container *ngIf="(premiumRequired && !brandingAvailable)" [ngbNavItem]="INFO_HeaderName">
              <a ngbNavLink><span translate>Settings.OrganisationBrandingSection.TabInfo</span></a>
              <ng-template ngbNavContent>
                <div class="pt-4">
                  <app-branding-tab-info></app-branding-tab-info>
                </div>
              </ng-template>
            </ng-container>
            <ng-container [ngbNavItem]="GENERAL_HeaderName" [disabled]="premiumRequired && (!brandingAvailable || !brandingEditable)">
              <a ngbNavLink><span translate>Settings.OrganisationBrandingSection.TabGeneral</span></a>
              <ng-template ngbNavContent>
                <div class="pt-4">
                  <app-branding-tab-general-organisation *ngIf="organisation" #general [Organisation]="organisation" [user]="user" [ssorequired]="ssorequired" [brandingStatus]="brandingStatus" [brandingEditable]="brandingEditable" [premiumRequired]="premiumRequired" (updateBrandingStatus)="updateBrandingStatusOrganisation($event)" (updateBrandingEditable)="updatebrandingEditable($event)" ></app-branding-tab-general-organisation>
                  <app-branding-tab-general-whitelabel *ngIf="whiteLabel" #general [whiteLabel]="whiteLabel" [user]="user" [ssorequired]="ssorequired" [brandingStatus]="brandingStatus" [brandingEditable]="brandingEditable" [premiumRequired]="premiumRequired" (updateBrandingStatus)="updateBrandingStatusWhiteLabel($event)" (updateBrandingEditable)="updatebrandingEditable($event)" ></app-branding-tab-general-whitelabel>
                  <app-branding-tab-general-system *ngIf="system" #general [system]="system" [user]="user" [ssorequired]="ssorequired" [brandingStatus]="brandingStatus" [brandingEditable]="brandingEditable" [premiumRequired]="premiumRequired" (updateBrandingStatus)="updateBrandingStatusOrganisation($event)" (updateBrandingEditable)="updatebrandingEditable($event)" ></app-branding-tab-general-system>
                </div>
              </ng-template>
            </ng-container>
            <ng-container [ngbNavItem]="IMAGES_HeaderName" [disabled]="premiumRequired && (!brandingAvailable || !brandingEditable)">
              <a ngbNavLink><span translate>Settings.OrganisationBrandingSection.TabImages</span></a>
              <ng-template ngbNavContent>
                <div class="pt-4">
                  <app-branding-tab-images-organisation *ngIf="organisation" #images [organisation]="organisation" [user]="user"></app-branding-tab-images-organisation>
                  <app-branding-tab-images-whitelabel *ngIf="whiteLabel" #images [whiteLabel]="whiteLabel" [user]="user"></app-branding-tab-images-whitelabel>
                  <app-branding-tab-images-system *ngIf="system" #images [system]="system" [user]="user"></app-branding-tab-images-system>
                </div>
              </ng-template>
            </ng-container>
            <ng-container [ngbNavItem]="COLOURS_HeaderName" [disabled]="premiumRequired && (!brandingAvailable || !brandingEditable)">
              <a ngbNavLink><span translate>Settings.OrganisationBrandingSection.TabColours</span></a>
              <ng-template ngbNavContent>
                <div class="pt-4">
                  <app-branding-tab-colours-organisation *ngIf="organisation" #colours [organisation]="organisation"></app-branding-tab-colours-organisation>
                  <app-branding-tab-colours-whitelabel *ngIf="whiteLabel" #colours [whiteLabel]="whiteLabel"></app-branding-tab-colours-whitelabel>
                  <app-branding-tab-colours-system *ngIf="system" #colours [system]="system"></app-branding-tab-colours-system>
                </div>
              </ng-template>
            </ng-container>
            <ng-container [ngbNavItem]="EMAIL_HeaderName" [disabled]="premiumRequired && (!brandingAvailable || !brandingEditable)">
              <a ngbNavLink><span translate>Settings.OrganisationBrandingSection.TabEmail</span></a>
              <ng-template ngbNavContent>
                <div class="pt-4">
                  <app-branding-tab-email-organisation *ngIf="organisation" #email [organisation]="organisation" [user]="user"></app-branding-tab-email-organisation>
                  <app-branding-tab-email-whitelabel *ngIf="whiteLabel" #email [whiteLabel]="whiteLabel" [user]="user"></app-branding-tab-email-whitelabel>
                  <app-branding-tab-email-system *ngIf="system" #email [system]="system" [user]="user"></app-branding-tab-email-system>
                </div>
              </ng-template>
            </ng-container>
            <div class="p-0">
                <hr class="hr" />
            </div>
          </nav>
          <div [ngbNavOutlet]="nav"></div>
    </div>
</div>
